// extracted by mini-css-extract-plugin
module.exports = {"flip":"flip--aa7f0"};